export enum ScreenNames {
    CHEFIT_ONE_MEAL_PAGE = "Chefit one meal page",
    CHEFIT_STAR_CLEANER_PAGE = "Chefit star cleaner page",
    CHEFIT_LOGIN_PAGE = "Chefit login page",
}